import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface GroupSessionActionsProps {
  hasPlayers: boolean;
  presentCount: number;
  totalCount: number;
  isMarkingAll: boolean;
  playersToEvaluateCount: number;
  onMarkAllPresent: () => void;
  onStartBulkEval: () => void;
}

export function GroupSessionActions({
  hasPlayers,
  presentCount,
  totalCount,
  isMarkingAll,
  playersToEvaluateCount,
  onMarkAllPresent,
  onStartBulkEval,
}: GroupSessionActionsProps) {
  const navigate = useNavigate();

  return (
    <>
      {hasPlayers && (
        <div className="flex gap-3">
          <Button
            onClick={onMarkAllPresent}
            disabled={isMarkingAll || presentCount === totalCount}
            className="flex-1"
          >
            {isMarkingAll ? 'Marking...' : 'Mark All Present'}
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="flex-1"
          >
            Done
          </Button>
        </div>
      )}

      {!hasPlayers && (
        <Button variant="outline" onClick={() => navigate(-1)} className="w-full">
          Done
        </Button>
      )}

      {playersToEvaluateCount > 0 && (
        <Button
          onClick={onStartBulkEval}
          className="w-full"
        >
          <Zap className="w-4 h-4 mr-2" />
          Start Evaluations ({playersToEvaluateCount} players)
        </Button>
      )}
    </>
  );
}
